import useSettingPrefStore from "~/store/setttingPref";

export function logoutCleaner() {
  const dark = useSettingPrefStore.getState().dark;
  localStorage.clear();

  if (dark) {
    useSettingPrefStore.getState().setDark(dark);
  }
}
